//components
import { Order, tableState, EnhancedTableProps } from './types';
//MUI
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import { Box, Typography } from '@mui/material';
import { isValid } from 'date-fns';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
	const _a = isValid(new Date(String(a[orderBy]))) ? new Date(String(a[orderBy])) : a[orderBy];
	const _b = isValid(new Date(String(b[orderBy]))) ? new Date(String(b[orderBy])) : b[orderBy];

	if (_b < _a) {
		return -1;
	}
	if (_b > _a) {
		return 1;
	}
	return 0;
}

export function getComparator<Key extends keyof any>(
	order: Order,
	orderBy: Key
): (a: { [key in Key]: number | string | Date }, b: { [key in Key]: number | string | Date }) => number {
	return order === 'desc'
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
	const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) {
			return order;
		}
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}
export const handleRequestSort = (tableState: tableState, setState: any, property: string) => {
	const isAsc = tableState.sortBy === property && tableState.orderBy === 'asc';
	setState({ ...tableState, orderBy: isAsc ? 'desc' : 'asc', sortBy: property });
};

export function EnhancedTableHead(props: EnhancedTableProps) {
	const { order, orderBy, onRequestSort, setState, tableState } = props;
	const createSortHandler = (property: string) => () => {
		onRequestSort(tableState, setState, property);
	};

	return (
		<TableHead>
			<TableRow>
				{props.headCells.map((headCell, inx) => (
					<TableCell
						key={headCell.name + inx}
						sortDirection={
							headCell.sortable === false ? false : orderBy === headCell.name ? order : false
						}
					>
						{headCell.hideHeaderLabel ? (
							<Box aria-hidden sx={{ minHeight: 24 }} />
						) : headCell.sortable === false ? (
							<Typography variant="body1">{headCell.title}</Typography>
						) : (
							<TableSortLabel
								active={orderBy === headCell.name}
								direction={orderBy === headCell.name ? order : 'asc'}
								onClick={createSortHandler(headCell.name)}
								IconComponent={ArrowDropDown}
							>
								<Typography variant="body1">{headCell.title}</Typography>
								{orderBy === headCell.name ? (
									<Box component="span" sx={visuallyHidden}>
										{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
									</Box>
								) : null}
							</TableSortLabel>
						)}
					</TableCell>
				))}
				<TableCell width="100%"></TableCell>
			</TableRow>
		</TableHead>
	);
}
